import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper from 'features/Agency/agencyHelper';
import ChargeHelper from 'features/Charge/chargeHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import DropdownFilterTable from 'general/components/DropdownFilterTable';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
    KTBSButtonColor,
    KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

PremiseListView.propTypes = {
    agencyId: PropTypes.string,
    showFullUI: PropTypes.bool,
    premiseListFilter: PropTypes.object,
    onFilterChanged: PropTypes.func,
};

const defaultColumnIds = [
    'PREMISE_CODE',
    'PREMISE_NAME',
    'PREMISE_TYPE',
    'PREMISE_AREA',
    'VEHICLE_TYPE',
    'PARKING_SLOT',
    'RENTAL_SCOPE',
    'RENTAL_FORM',
    'PREMISE_STATUS',
    'CONTRACT_STATUS',
    'LANDLORD_NAME',
    'STATION_CODE',
    'RELATED_ORDER',
    'ADDRESS',
    'CREATED_BY',
    'DATE',
];

function PremiseListView(props) {
    // MARK: ---- PROPERTIES ----
    const { showFullUI = true, agencyId, premiseListFilter, onFilterChanged = () => { } } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const { user } = useSelector((state) => state.auth);
    const [operatorList, setOperatorList] = useState([]);
    const [filter, setFilter] = useState(premiseListFilter);
    const [filterDropdown, setFilterDropdown] = useState(premiseListFilter);
    const [premiseList, setPremiseList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const commissionRateLandlord = useAppConfig()?.commissionRateLandlord;

    useEffect(() => {
        setFilter(premiseListFilter);
    }, [premiseListFilter])

    // khu vuc
    const areaTree = useSelector((state) => state.app.areaTree);
    const areaProvinceList = useMemo(() => {
        return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
    }, [areaTree]);
    const areaProvinceOptions = useMemo(() => {
        return _.map(areaProvinceList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaProvinceList]);
    const [selectedAreaProvince, setSelectedAreaProvince] = useState();
    const areaDistrictList = useMemo(() => {
        if (!selectedAreaProvince) return [];
        return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
    }, [areaTree, selectedAreaProvince]);
    const areaDistrictOptions = useMemo(() => {
        return _.map(areaDistrictList, (item) => {
            return {
                name: item.name,
                value: item.areaId,
            };
        });
    }, [areaDistrictList]);
    const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
    useEffect(() => {
        const areaId = filterDropdown.areaId;
        if (Utils.isValid(areaId)) {
            const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
            if (area?.typeCode === 'P') {
                setSelectedAreaProvince(area);
            } else {
                setSelectedAreaDistrict(area);
                const parentAreaId = area?.parentId;
                if (Utils.isValid(parentAreaId)) {
                    setSelectedAreaProvince(ChargeHelper.Utils.getAreaById([areaTree], parentAreaId));
                }
            }
        }
    }, [filterDropdown?.areaId, areaTree]);

    const typeMap = {
        CAR: "Ô tô",
        BIKE: "Xe máy"
    };

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'PREMISE_CODE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Mã mặt bằng')}
                    </span>
                ),
                selector: (row) => row?.premiseCode ?? row?.premiseId,
                style: tableStyle.columns.normal,
                sortable: false,
                width: '120px',
            },
            {
                id: 'PREMISE_NAME',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Tên mặt bằng')}
                    </span>
                ),
                minWidth: '240px',
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.name ?? ''}>
                            <span>{row?.name ?? ''}</span>
                        </KTTooltip>
                    )
                },
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'PREMISE_TYPE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Loại mặt bằng')}
                    </span>
                ),
                selector: (row) => {
                    const premiseTypeName = commissionRateLandlord ? JSON.parse(commissionRateLandlord)?.find(landlord => landlord?.key === row?.type)?.name : '';
                    return (
                        <KTTooltip offset={[0, 0]} text={premiseTypeName ?? ''}>
                            <span>{premiseTypeName ?? ''}</span>
                        </KTTooltip>
                    )
                },
                style: tableStyle.columns.normal,
                sortable: false,
                width: '250px',
            },
            {
                id: 'PREMISE_AREA',
                name: (
                    <div className="w-100 d-flex flex-column align-items-end">
                        <div
                            className="letter-spacing-unset"
                            style={{
                                fontSize: 12,
                                color: AppColors.gray[900],
                            }}
                        >
                            {t('Diện tích')}
                        </div>
                        <div
                            className="letter-spacing-unset font-weight-bold"
                            style={{ color: AppColors.gray[700] }}
                        >
                            m2
                        </div>
                    </div>
                ),
                selector: (row) => row?.floorArea ?? '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '120px',
                right: true,
            },
            {
                id: 'VEHICLE_TYPE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Loại phương tiện')}
                    </span>
                ),
                selector: (row) => row?.vehicleTypes?.length > 0
                    ? row?.vehicleTypes?.map((type, index) => index === 0 ? typeMap[type] : typeMap[type].toLowerCase()).join(", ")
                    : '',
                style: tableStyle.columns.normal,
                minWidth: '150px',
            },
            {
                id: 'PARKING_SLOT',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Chỗ đỗ xe ô tô')}
                    </span>
                ),
                selector: (row) => row?.parkingSlots ?? '',
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '120px',
                right: true,
            },
            {
                id: 'RENTAL_SCOPE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Phạm vi thuê')}
                    </span>
                ),
                selector: (row) => row?.rentingType ? AgencyHelper.Data.rentingTypeOptions.find(type => type.value === row?.rentingType)?.name : '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
            },
            {
                id: 'RENTAL_FORM',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Hình thức thuê')}
                    </span>
                ),
                selector: (row) => handleGetRentingForm(row),
                style: tableStyle.columns.normal,
                minWidth: '200px',
            },
            {
                id: 'PREMISE_STATUS',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Trạng thái mặt bằng')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={AgencyHelper.Utils.getPremiseStatusName(row?.status)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${AgencyHelper.Utils.getPremiseStatusColor(
                                row?.status
                            )}`}
                        />
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
                width: '150px',
            },
            {
                id: 'CONTRACT_STATUS',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Trạng thái hợp đồng')}
                    </span>
                ),
                selector: (row) => {
                    const contractStatus = row?.sales?.[0]?.contracts?.[0]?.status;

                    if (!contractStatus) return null;

                    return (
                        <KTLabel
                            text={AgencyHelper.Utils.getPremiseContractStatusName(contractStatus)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${AgencyHelper.Utils.getPremiseContractStatusColor(contractStatus)}`}
                            additionalDescription={row?.cancelingReason}
                        />
                    );
                },
                width: '150px',
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'LANDLORD_NAME',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Chủ mặt bằng')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.landlord?.name}>
                            <span
                                className="cursor-pointer hover-opacity-60"
                                onClick={() => {
                                    Utils.openInNewTab(`${AppRoute.landlordList}/${row?.landlordId}`);
                                }}
                            >
                                {row?.landlord?.name}
                            </span>
                        </KTTooltip>
                    );
                },
                width: '160px',
                style: tableStyle.columns.link,
                sortable: false,
            },
            {
                id: 'STATION_CODE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Mã trạm sạc')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <div className='d-flex justify-content-end'>
                            {row?.chargeStations?.length ? row?.chargeStations?.map((item, index) => {
                                return (
                                    <div className='cursor-pointer'
                                        onClick={() => {
                                            Utils.openInNewTab(`${AppRoute.stationList}/${item?.stationId}`);
                                        }}>
                                        {item?.stationCode ?? item?.stationId}
                                        {index !== row?.chargeStations?.length - 1 ? <span className='mr-1'>,</span> : <></>}
                                    </div>
                                )
                            }) : ''}
                        </div>
                    );
                },
                sortable: false,
                minWidth: '250px',
                style: tableStyle.columns.link,
            },
            {
                id: 'RELATED_ORDER',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Đơn hàng liên quan')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <span
                            className="cursor-pointer hover-opacity-60"
                            onClick={() => {
                                Utils.openInNewTab(`${AppRoute.orderList}/${row?.sales[0]?.saleId}`);
                            }}
                        >
                            {row?.sales[0]?.saleId}
                        </span>
                    );
                },
                sortable: false,
                minWidth: '140px',
                style: tableStyle.columns.link,
            },
            {
                id: 'ADDRESS',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Địa chỉ')}
                    </span>
                ),
                selector: (row) => {
                    const area = ChargeHelper.Utils.getAreaById([areaTree], row?.areaId);
                    let parentArea;
                    if (area?.typeCode === 'W') {
                        parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
                    }
                    const addressResuslt = [row.address, area?.name, parentArea?.name]
                        .filter(Boolean)
                        .join(', ');
                    return (
                        <KTTooltip text={addressResuslt} offset={[0, 0]}>
                            <span>{addressResuslt?.length > 0 ? addressResuslt : ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
                minWidth: '250px',
            },
            {
                id: 'CREATED_BY',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Người tạo/giới thiệu')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.agency?.name}>
                            <span
                                className="cursor-pointer hover-opacity-60"
                                onClick={() => {
                                    Utils.openInNewTab(`${AppRoute.saleList}/${row?.agencyId}`);
                                }}
                            >
                                {row?.agency?.name}
                            </span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                width: '220px',
            },
            {
                id: 'DATE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('Ngày tạo')}
                    </span>
                ),
                selector: (row) => Utils.formatDateTimeToString(row.createdAt, 'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
            },
            {
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('actions')}
                    </span>
                ),
                width: '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                wrap: true,
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Xem chi tiết'),
                                    click: () => {
                                        handleClickedRow(row);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('edit'),
                                    click: () => {
                                        if (!agencyId) {
                                            router.navigate(`${row?.premiseId}/edit`);
                                        } else {
                                            Utils.openInNewTab(`${AppRoute.premisesList}/${row?.premiseId}/edit`);
                                        }
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-play"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('unStopWorking'),
                                    click: () => {
                                        handleActivePremise(row);
                                    },
                                    show: row?.status === 'DELETED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Xóa mặt bằng'),
                                    click: () => {
                                        handleDeletePremise(row);
                                    },
                                    show: row?.status !== 'DELETED' && row?.status !== 'RENTED',
                                },
                            ]}
                        />
                    );
                },
            },
        ];
    }, [t, operatorList, areaTree, user, filter, commissionRateLandlord]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    useEffect(() => {
        handleGetPremiseList();
    }, [filter]);
    // MARK: ---- METHODS ----
    const handleGetPremiseList = () => {
        setIsLoading(true);
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        AgencyHelper.API.requestGetPremiseList(params)
            .then((response) => {
                setPremiseList(response?.premises);
                setTotal(response?.total);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const handleDeletePremise = async (row) => {
        AppDialogHelper.show(
            `Xóa mặt bằng`,
            `Bạn có chắc muốn xóa mặt bằng <span class="font-weight-boldest text-gray-800">${row?.name}</span> không? Bạn vẫn có thể khôi phục sau khi đã xóa.`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Xóa',
                    type: 'negative',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const result = await AgencyHelper.API.requestUpdatePremise(row?.premiseId, { status: 'DELETED' });
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Xoá mặt bằng thành công');
                            handleGetPremiseList();
                        } else {
                            ToastHelper.showError(result || 'Xoá mặt bằng thất bại');
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogDeleteVehicle
        );
    }

    const handleActivePremise = async (row) => {
        AppDialogHelper.show(
            'Khôi phục hoạt động',
            `Bạn có chắc muốn khôi phục hoạt động mặt bằng <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Khôi phục hoạt động',
                    type: 'success',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const isSuccess = await AgencyHelper.API.requestUpdatePremise(row?.premiseId, { status: 'AVAILABLE' });
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Khôi phục hoạt động thành công`);
                            handleGetPremiseList();
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogActiveAgency
        );
    }

    const handleClickedRow = (row) => {
        if (!agencyId) {
            router.navigate(`${row.premiseId}`);
        } else {
            Utils.openInNewTab(`${AppRoute.premisesList}/${row.premiseId}`);
        }
    };

    const handleGetRentingForm = (row) => {
        const landlordCommission = row?.landlord?.commissions?.find(
            (commission) => commission?.role === 'LANDLORD'
                && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
        );

        if (!row) return 'Không xác định';

        const hasMonthlyRent = row.monthlyRent > 0;
        const hasLandlordCommission = !!landlordCommission;

        if (!hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Miễn phí';
        if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';
        if (hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Có phí';
        if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';

        return 'Không xác định';
    };

    const rentingFormOptions = [
        { value: '', name: 'Tất cả' },
        { value: '1', name: 'Miễn phí' },
        { value: '0', name: 'Có phí' },
    ]

    const handleFilterChanged = (filter) => {
        if (onFilterChanged) {
            onFilterChanged(filter);
        }
    };

    const updateFilter = (key, value) => {
        if (!!agencyId) {
            handleFilterChanged({ [key]: value, page: 0 });
        } else {
            Global.g_filterPremisesList = { ...Global.g_filterPremisesList, [key]: value };
            setFilter(Global.g_filterPremisesList);
            setFilterDropdown(Global.g_filterPremisesList);
        }
    };

    const FilterComponentList = ({ isInDropdown = false }) => (
        <div className={`${isInDropdown ? 'row' : 'w-100'} d-flex  flex-row  flex-wrap`}>
            {/* loai mat bang */}
            <KTDropdownFilter
                label={t('Loại mặt bằng')}
                filterKey="type"
                options={[
                    { name: t('all'), value: '' },
                    ...(commissionRateLandlord
                        ? JSON.parse(commissionRateLandlord).map((landlord) => ({
                            name: landlord.name,
                            value: landlord.key,
                        }))
                        : []),
                ]}
                selectedValue={!isInDropdown ? filter.type : filterDropdown.type}
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pr-2 pt-4' : 'pl-0 pr-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown((prev) => ({ ...prev, type: value }));
                    } else {
                        updateFilter('type', value);
                    }
                }}
            />

            {/* loai phuong tien */}
            <KTDropdownFilter
                label={t('Loại phương tiện')}
                filterKey="vehicleTypes"
                options={[
                    { name: t('all'), value: '' },
                    ...ChargeHelper.Data.vehicleTypeOptions
                ]}
                selectedValue={
                    !isInDropdown ? filter.vehicleTypes : filterDropdown.vehicleTypes
                }
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pl-2 pt-4' : 'pl-0 pr-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, vehicleTypes: value });
                    } else {
                        updateFilter('vehicleTypes', value);
                    }
                }}
            />

            {/* pham vi thue */}
            <KTDropdownFilter
                label={t('Phạm vi thuê')}
                filterKey="rentingType"
                options={[
                    { name: t('all'), value: '' },
                    ...AgencyHelper.Data.rentingTypeOptions
                ]}
                selectedValue={!isInDropdown ? filter.rentingType : filterDropdown.rentingType}
                isInDropdown={isInDropdown}
                additionalClassName={`${isInDropdown ? 'pr-2 pt-2' : 'pl-0 pr-0 pr-xl-4'}`}
                handleChange={(value) => {
                    if (isInDropdown) {
                        setFilterDropdown({ ...filterDropdown, rentingType: value });
                    } else {
                        updateFilter('rentingType', value);
                    }
                }}
            />

            {isInDropdown && (
                <>

                    {/* hinh thuc thue */}
                    <KTDropdownFilter
                        label={t('Hình thức thuê')}
                        filterKey="rentalForm"
                        options={rentingFormOptions}
                        selectedValue={isInDropdown
                            ? filterDropdown.free
                            : filter.free
                        }
                        isInDropdown={isInDropdown}
                        additionalClassName="pl-2 pt-2"
                        handleChange={(value) => {
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, free: value });
                            } else {
                                updateFilter('free', value);
                            }
                        }}
                    />

                    {/* trang thai mat bang */}
                    <KTDropdownFilter
                        label={t('Trạng thái mặt bằng')}
                        filterKey="status"
                        options={[
                            { name: t('all'), value: '' },
                            ...AgencyHelper.Data.premiseStatusOptions
                        ]}
                        selectedValue={isInDropdown ? filterDropdown.status : filter.status}
                        isInDropdown={isInDropdown}
                        additionalClassName={`${isInDropdown ? 'pr-2 pt-2' : 'pl-0 pr-0 pr-xl-4'}`}
                        handleChange={(value) => {
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, status: value });
                            } else {
                                updateFilter('status', value);
                            }
                        }}
                    />

                    {/* trang thai hop dong */}
                    <KTDropdownFilter
                        label={t('Trạng thái hợp đồng')}
                        filterKey="contractStatus"
                        options={[
                            { name: t('all'), value: '' },
                            ...AgencyHelper.Data.premiseContractStatusOptions
                        ]}
                        selectedValue={isInDropdown ? filterDropdown.contractStatus : filter.contractStatus}
                        isInDropdown={isInDropdown}
                        additionalClassName={`${isInDropdown ? 'pl-2 pt-2' : 'pl-0 pr-0 pl-xl-4'}`}
                        handleChange={(value) => {
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, contractStatus: value });
                            } else {
                                updateFilter('contractStatus', value);
                            }
                        }}
                    />

                    <KTDropdownFilter
                        label={t('city')}
                        filterKey="areaId"
                        options={areaProvinceOptions}
                        selectedOption={selectedAreaProvince}
                        selectedValue={filterDropdown.areaId}
                        isInDropdown={isInDropdown}
                        additionalClassName="pr-2 pt-2"
                        searchable={true}
                        handleChange={(value) => {
                            const province = _.find(areaProvinceList, (item) => item.areaId === value);
                            setSelectedAreaProvince(province);
                            setSelectedAreaDistrict('');
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, areaId: value });
                            } else {
                                updateFilter('areaId', value);
                            }
                        }}
                    />

                    <KTDropdownFilter
                        label={t('district')}
                        filterKey="areaId"
                        options={areaDistrictOptions}
                        selectedOption={selectedAreaDistrict}
                        selectedValue={filterDropdown.areaId}
                        isInDropdown={isInDropdown}
                        additionalClassName="pl-2 pt-2"
                        searchable={true}
                        handleChange={(value) => {
                            setSelectedAreaDistrict(_.find(areaDistrictList, (item) => item.areaId === value));
                            if (isInDropdown) {
                                setFilterDropdown({ ...filterDropdown, areaId: value });
                            } else {
                                updateFilter('areaId', value);
                            }
                        }}
                    />
                </>
            )}
        </div>
    );

    // them mat bang
    const handleOpenAddPremiseScreen = () => {
        router.navigate('add');
    };

    return (
        <div className=''>
            {UIHelper.buildCard(
                <div>
                    {/* header */}
                    {showFullUI && (
                        <div className="px-4 pt-4 d-flex justify-content-between align-items-center">
                            {/* title */}
                            <div className="d-flex flex-column align-items-start">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Danh sách mặt bằng
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng số:{' '}
                                    <span style={{ color: AppColors.primary }}>
                                        {total ?? premiseList?.length} {t('mặt bằng')}
                                    </span>
                                </span>
                            </div>

                            {/* actions */}
                            <div className="d-flex gap-3">
                                <KTBSButton
                                    color={KTBSButtonColor.success}
                                    title={t('Thêm mặt bằng')}
                                    size={KTBSButtonSize.default}
                                    borderRadius={5}
                                    buttonTitleFontWeight="600"
                                    iconElement={<i className="fa-regular fa-circle-plus" style={{ fontSize: 15 }} />}
                                    onPress={handleOpenAddPremiseScreen}
                                    height={43}
                                    buttonTitleFontSize={14}
                                />
                            </div>
                        </div>
                    )}

                    {/* body */}
                    <div className="">
                        {/* filter */}
                        <div className="w-100 d-flex align-items-end flex-wrap pb-4 px-4">
                            <div className={`col-lg-3 py-2 pr-0 pr-xl-4 pr-lg-4 pl-0`}>
                                <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                                    {t('search')}
                                </label>
                                <KTFormSearch
                                    name="search-bar"
                                    placeholder={t('Theo mã mặt bằng, tên mặt bằng, địa chỉ...')}
                                    value={filter.q}
                                    onSubmit={(text) => {
                                        if (!!agencyId) {
                                            handleFilterChanged({
                                                q: text,
                                                page: 0,
                                            });
                                        } else {
                                            Global.g_filterPremisesList = {
                                                ...Global.g_filterPremisesList,
                                                q: text,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterPremisesList);
                                            setFilterDropdown(Global.g_filterPremisesList);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-xl-7 col-lg-9 px-0">
                                <FilterComponentList />
                            </div>

                            {/* bo loc */}
                            <div className="py-2 pr-4">
                                <DropdownFilterTable
                                    filterComponent={[
                                        <div className={`${'col-12 p-0'}`}>
                                            <KTFormSearch
                                                name="search-bar"
                                                placeholder={t('Theo mã mặt bằng, tên mặt bằng, địa chỉ...')}
                                                value={filterDropdown.q}
                                                onSubmit={(text) => {
                                                    const updateFilterDropdown = { ...filterDropdown, q: text };
                                                    setFilterDropdown(updateFilterDropdown);
                                                }}
                                            />
                                        </div>,
                                        <FilterComponentList
                                            isInDropdown={true}
                                            onChange={(filter) => {
                                                setFilterDropdown({
                                                    ...filterDropdown,
                                                    ...filter,
                                                });
                                            }}
                                        />,
                                    ]}
                                    resetDefaultTable={() => {
                                        if (!!agencyId) {
                                            handleFilterChanged({
                                                q: '',
                                                status: '',
                                                areaId: '',
                                                type: '',
                                                vehicleTypes: '',
                                                rentingType: '',
                                                rentalForm: '',
                                                status: '',
                                                contractStatus: '',
                                                landlordId: agencyId || '',
                                            });
                                            const updateFilterDropdown = {
                                                ...filterDropdown,
                                                q: '',
                                                status: '',
                                                areaId: '',
                                                type: '',
                                                vehicleTypes: '',
                                                rentingType: '',
                                                rentalForm: '',
                                                status: '',
                                                contractStatus: '',
                                                landlordId: agencyId || '',
                                            };
                                            setFilterDropdown(updateFilterDropdown);
                                        } else {
                                            const updateFilterDropdown = {
                                                ...filterDropdown,
                                                q: '',
                                                status: '',
                                                areaId: '',
                                                type: '',
                                                vehicleTypes: '',
                                                rentingType: '',
                                                rentalForm: '',
                                                status: '',
                                                contractStatus: '',
                                                free: '',
                                            };
                                            setFilterDropdown(updateFilterDropdown);
                                            setFilter(updateFilterDropdown);
                                            Global.g_filterPremisesList = updateFilterDropdown;
                                        }
                                        setSelectedAreaProvince('');
                                        setSelectedAreaDistrict('');
                                    }}
                                    saveFilter={() => {
                                        if (!!agencyId) {
                                            handleFilterChanged({
                                                q: filterDropdown?.q,
                                                status: filterDropdown?.status,
                                                areaId: filterDropdown?.areaId,
                                                type: filterDropdown?.type,
                                                vehicleTypes: filterDropdown?.vehicleTypes,
                                                rentingType: filterDropdown?.rentingType,
                                                rentalForm: filterDropdown?.rentalForm,
                                                status: filterDropdown?.status,
                                                contractStatus: filterDropdown?.contractStatus,
                                                page: 0,
                                            });
                                        } else {
                                            setFilter(filterDropdown);
                                            Global.g_filterPremisesList = filterDropdown;
                                        }
                                    }}
                                    isDefaultFilter={Utils.checkDefaultFilter(
                                        ['page', 'limit', 'landlordId'],
                                        filter,
                                        true,
                                        false
                                    )}
                                />
                            </div>
                            {/* cau hinh cot */}
                            <div className="pr-0 py-2">
                                <DropdownTableConfigColumn
                                    columnIds={columnIds}
                                    fullColumns={fullColumns}
                                    fullColumnIds={fullColumnsIdSorted}
                                    onChangeCheckboxValue={onChangeCheckboxValue}
                                    saveChanges={saveChanges}
                                    resetDefaultTableColumn={() => {
                                        setFullColumnIds(defaultColumnIds);
                                        resetDefaultTableColumn();
                                    }}
                                    onChangeFullColumnIds={(ids) => {
                                        setFullColumnIds(ids);
                                        const key = prefKey + '_FULL_COLUMN_IDS';
                                        localStorage.setItem(key, ids.join('|'));
                                    }}
                                    onSelectAll={onSelectAll}
                                    onUnSelectAll={onUnSelectAll}
                                />
                            </div>
                        </div>

                        {/* table */}
                        <div className="px-4">
                            <KTTable
                                columns={columns}
                                items={premiseList}
                                selectableRows={false}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(rows) => { }}
                                onDoubleClickedRow={(rows) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                    />
                                }
                            />
                        </div>

                        {/* phan trang */}
                        <div className={`mt-4 px-4 ${!agencyId ? 'mb-4' : ''}`}>
                            <KTPagination
                                currentPage={filter.page + 1}
                                rowCount={total != 0 ? total : premiseList?.length}
                                rowsPerPage={filter.limit}
                                currentItemInPageCount={premiseList?.length}
                                onChangePage={(newPage) => {
                                    const iNewPage = parseInt(newPage);
                                    if (!!agencyId) {
                                        handleFilterChanged({
                                            page: iNewPage - 1,
                                        });
                                    } else {
                                        Global.g_filterPremisesList = {
                                            ...Global.g_filterPremisesList,
                                            page: iNewPage - 1,
                                        };
                                        setFilter(Global.g_filterPremisesList);
                                    }
                                }}
                                onChangeRowsPerPage={(newRowsPerPage) => {
                                    const iNewRowsPerPage = parseInt(newRowsPerPage);
                                    if (!!agencyId) {
                                        handleFilterChanged({
                                            limit: iNewRowsPerPage,
                                            page: 0,
                                        });
                                    } else {
                                        Global.g_filterPremisesList = {
                                            ...Global.g_filterPremisesList,
                                            limit: iNewRowsPerPage,
                                            page: 0,
                                        };
                                        setFilter(Global.g_filterPremisesList);
                                    }
                                }}
                                color={KTPaginationColor.success}
                                appendText="mặt bằng"
                            />
                        </div>
                    </div>
                </div>,
                false,
                !showFullUI
            )}
        </div>
    );
}

export default PremiseListView;
